import React, { useState } from 'react';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useTheme } from '@mui/material/styles';

function Home() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const theatreData = [
    {
      year: '2006-2024',
      title: '“La République, c’est nous”',
      director: 'Salika Amara',
      role: 'Rôle de la mère, Colette',
      image: '/images/post1.webp',
    },
    {
      year: '2023',
      title: '“Olympe” pièce interactive de fin d’année',
      director: 'association culturelle',
      role: 'Hera, la femme de Zeus',
      image: '/images/post2.webp',
    },
  ];
  
  const filmData = [
    {
      year: '2024',
      title: 'Film',
      director: null,
      role: 'Rôle : figuration policière municipale',
      image: '/images/post3.webp',
    },
    {
      year: '2008',
      title: 'Sa raison d’Être, avec Clémentine Célarié et Philippe Lefebvre',
      director: 'Renaud Bertrand',
      role: 'Scène : En robe de soirée à la Maison de l’Amérique latine pour le cocktail des années Chirac, je discutais avec les autres tout en mangeant et buvant au buffet',
      image: '/images/post5.webp',
    },
    {
      year: '2007',
      title: 'Après Lui, avec Catherine Deneuve',
      director: 'Gaël Morel',
      role: 'Figuration : dans une salle de concert, je patientais au bar avec une pinte de bière, à l’annonce du début du concert, j’ai traversé la foule et me suis dirigée vers la scène en bousculant Catherine Deneuve.',
      image: '/images/post4.webp',
    },
    {
      year: '2006',
      title: 'En parlant de Bill, court métrage',
      director: null,
      role: 'Scène : Je faisais la queue au guichet pour aller voir un film.',
      image: null,
    }
  ];
  
  const tvData = [
    {
      year: '2010',
      title: 'Émission "Qui sera le meilleur Sosie"',
      director: 'Présentateur : Christophe Dechavanne',
      role: 'Sosie de Serena Williams',
      image: '/images/post6.webp',
    },
    {
      year: '2000-2023',
      title: 'Diverses émissions',
      role: 'Figuration',
      image: null,
    },
  ];

  // Liste des images de la galerie
  const images = [
    '/images/1.jpg',
    '/images/2.webp',
    '/images/3.webp',
    '/images/4.webp',
    '/images/5.webp',
    '/images/6.webp',
    '/images/7.webp',
    '/images/8.webp',
    '/images/9.webp',
    '/images/10.webp',
    '/images/11.webp',
    '/images/12.webp',
  ];

  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [showFullProfile, setShowFullProfile] = useState(false);

  const handleThumbnailClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Sur mobile, on affiche toujours le profil complet
  const profileVisible = isMobile ? true : showFullProfile;

  // Photo 1,  : plein-pied => objectFit: 'contain'
  // const objectFitValue = selectedImageIndex === 1 ? 'contain' : 'cover';

  // Fonction d’aide pour afficher "Réalisateur" (ou "Présentateur") 
  // en gras + gris, et la partie valeur en normal
  const DirectorLine = ({ director }) => {
    if (!director) return null; // si director est null, on n'affiche rien

    // On découpe la chaîne au premier ":"
    // ex: "Réalisateur : Gaël Morel" => labelPart="Réalisateur", valuePart="Gaël Morel"
    const splitted = director.split(':', 2);
    const labelPart = splitted[0].trim();
    const valuePart = splitted[1] ? splitted[1].trim() : null;

    return (
      <Typography
        sx={{
          fontFamily: 'Josefin Sans',
          color: '#e6e6e6',
          // on retire le ml pour éviter l'écart à gauche
        }}
      >
        <Box component="span" sx={{ color: '#aaaaaa', fontWeight: 'bold' }}>
          {labelPart}
        </Box>
        {valuePart && (
          <Box component="span" sx={{ color: '#e6e6e6', fontWeight: 'normal' }}>
            : {valuePart}
          </Box>
        )}
      </Typography>
    );
  };

  // Petit composant utilitaire pour lister un item
  // Au lieu d'une image de 50×50, on affiche un "poster" vertical plus grand,
  // S’il n’y a pas d’image, on n’affiche pas le conteneur du tout.
  const RenderItem = ({ year, image, title, director, role }) => {
    return (
      <Box
        sx={{
          display: 'flex',
          mb: 4,
          // Sur mobile => stack vertical, Sur desktop => row
          flexDirection: { xs: 'column', md: 'row' },
          gap: 2,
          alignItems: 'flex-start',
        }}
      >
        {/* Vignette style "affiche de film" */}
        {image && (
          <Box
            component="img"
            src={image}
            alt="vignette"
            sx={{
              width: { xs: '100%', md: '120px' },  // Largeur en desktop
              height: { xs: 'auto', md: '180px' }, // Hauteur en desktop => style "poster"
              objectFit: 'cover',
              borderRadius: '4px',
            }}
          />
        )}

        {/* Colonne de texte (année, titre, réalisateur, rôle) */}
        <Box sx={{ flex: 1 }}>
          {/* Année */}
          <Typography
            sx={{
              fontFamily: 'Josefin Sans',
              color: '#e6e6e6',
              mb: 0.5,
            }}
          >
            {year}
          </Typography>

          {/* Titre */}
          <Typography
            sx={{
              fontFamily: 'Josefin Sans',
              color: '#ffffff',
              fontWeight: 'bold',
              mb: 0.5,
            }}
          >
            {title}
          </Typography>

          {/* Réalisateur / Présentateur */}
          <DirectorLine director={director} />

          {/* Rôle / description */}
          {role && (
            <Typography
              sx={{
                fontFamily: 'Josefin Sans',
                color: '#e6e6e6',
                mt: 0.5,
              }}
            >
              {role}
            </Typography>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={{ fontFamily: 'Josefin Sans', width: '100%', minHeight: '100vh', boxSizing: 'border-box' }}>
      <Navbar showLanguageSelector={false} showThemeSwitch={false} />

      <Grid
        container
        sx={{
          width: '100%',
          minHeight: '100vh',
          flexWrap: { xs: 'wrap', md: 'nowrap' },
        }}
      >
        {/* Bloc gauche : Galerie photo */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            position: { xs: 'relative', md: 'sticky' },
            top: 0,
            alignSelf: 'flex-start',
            height: { xs: '100vh', md: '100vh' },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            boxSizing: 'border-box',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            <Box
              component="img"
              src={images[selectedImageIndex]}
              alt="Photo principale"
              sx={{
                width: '100%',
                height: 'auto',
                maxHeight: '100%',
                objectFit: 'cover',
              }}
            />
          </Box>

          {/* Thumbnails */}
<Box
  sx={{
    width: '100%',
    display: 'flex',
    justifyContent: { xs: 'flex-start', md: 'center' },
    alignItems: 'center',
    gap: 1,
    backgroundColor: 'rgba(0,0,0,0.3)',
    position: 'absolute',
    bottom: 0,
    p: 1,
    overflowX: { xs: 'auto', md: 'visible' },
    flexWrap: { xs: 'nowrap', md: 'wrap' },
  }}
>
  {images.map((img, index) => (
    <Box
      key={index}
      component="img"
      src={img}
      alt={`thumbnail-${index}`}
      onClick={() => handleThumbnailClick(index)}
      sx={{
        width: 50,
        height: 50,
        borderRadius: '4px',
        cursor: 'pointer',
        border:
          selectedImageIndex === index
            ? '2px solid #fff'
            : '2px solid transparent',
        objectFit: 'cover',
      }}
    />
  ))}
</Box>
        </Grid>

        {/* Bloc droit : Présentation */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            position: 'relative',
            backgroundColor: '#000000',
            color: '#ffffff',
            p: { xs: 2, md: 6 },
            boxSizing: 'border-box',
            marginTop: { xs: 0, md: 8 },
          }}
        >

          <Box
            sx={{
              opacity: profileVisible ? 1 : 0,
              transform: profileVisible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'opacity 0.8s ease, transform 0.8s ease',
            }}
          >
            {/* Nom (desktop) */}
              <Typography
                variant="h5"
                sx={{ fontFamily: 'Josefin Sans', fontWeight: 'bold', mb: 2, textAlign: { xs: "center", md: "left" } }}
              >
                Jocelyne JEAN-BAPTISTE
              </Typography>

            {/* Comédienne passionnée ... + liste */}
            <Typography variant="body1" sx={{ fontFamily: 'Josefin Sans', color:'#e6e6e6', mb:1 }}>
              Comédienne passionnée basée à Paris, intéressée pour des propositions telles que:
            </Typography>
            <Box 
              component="ul" 
              sx={{ 
                listStyle: 'disc', 
                ml: 4, 
                mb: 3, 
                color:'#e6e6e6', 
                fontFamily: 'Josefin Sans' 
              }}
            >
              <Box component="li">Shooting</Box>
              <Box component="li">Campagnes publicitaires</Box>
              <Box component="li">Figuration</Box>
              <Box component="li">Court ou long métrage</Box>
              <Box component="li">Emissions télévisées</Box>
            </Box>

            {/* TITRE "INFORMATION" avec fond gris */}
            <Box id="information">
            <Typography
              variant="h6"
              sx={{
                backgroundColor: '#444444',
                color:'#ffffff',
                width:'100%',
                py:1,
                textAlign:'center',
                fontFamily:'Josefin Sans',
                fontWeight:'bold',
                mb:1
              }}
            >
              Information
            </Typography>

            {/* 2 COLONNES INFORMATIONS */}
            <Box 
              sx={{ 
                display: 'grid', 
                gridTemplateColumns: { xs:'1fr', sm:'1fr 1fr' }, 
                columnGap: 4, 
                rowGap: 2,
                mb: 2 
              }}
            >
              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Âge de jeu
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  50-60 ans
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Année de naissance
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  1967
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Taille (cm)
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  173
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Poids (kg)
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  70
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Couleur des yeux
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  marron
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Couleur des cheveux
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  châtain foncé
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Longueur de cheveux
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  mi-long
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Lieu de résidence
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  Paris, France
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Lieu de naissance
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  Antilles, Haïti
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Nationalité
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  Française
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Langues
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  Français, Créole Haïtien
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Sport
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  gym, marche à pied
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Danse
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6' }}>
                  danse orientale
                </Typography>
              </Box>

              <Box sx={{ display:'flex', justifyContent:'space-between' }}>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', fontWeight:'bold' }}>
                  Profession
                </Typography>
                <Typography sx={{ fontFamily:'Josefin Sans', color:'#e6e6e6', textAlign: "right" }}>
                  Fonctionnaire, agent de mairie, accueil administratif
                </Typography>
              </Box>
            </Box>
          </Box>

            {/* ===== Théâtre ===== */}
            <Box id="theatre">
            <Typography
              variant="h6"
              sx={{
                backgroundColor: '#444444',
                color: '#ffffff',
                width: '100%',
                py: 1,
                textAlign: 'center',
                fontFamily: 'Josefin Sans',
                fontWeight: 'bold',
                mb: 2,
              }}
            >
              Théâtre
            </Typography>
            {theatreData.map((item, idx) => (
              <RenderItem
                key={idx}
                year={item.year}
                title={item.title}
                director={item.director ? `Metteur en scène : ${item.director}` : null}
                role={item.role}
                image={item.image}
              />
            ))}
          </Box>

            {/* ===== Film ===== */}
            <Box id="film">
            <Typography
              variant="h6"
              sx={{
                backgroundColor: '#444444',
                color: '#ffffff',
                width: '100%',
                py: 1,
                textAlign: 'center',
                fontFamily: 'Josefin Sans',
                fontWeight: 'bold',
                mb: 2,
              }}
            >
              Film
            </Typography>
            {filmData.map((item, idx) => (
              <RenderItem
                key={idx}
                year={item.year}
                title={item.title}
                director={item.director ? `Réalisateur : ${item.director}` : null}
                role={item.role}
                image={item.image}
              />
            ))}
          </Box>

            {/* ===== Télévision ===== */}
            <Box id="television">
            <Typography
              variant="h6"
              sx={{
                backgroundColor: '#444444',
                color: '#ffffff',
                width: '100%',
                py: 1,
                textAlign: 'center',
                fontFamily: 'Josefin Sans',
                fontWeight: 'bold',
                mb: 2,
              }}
            >
              Télévision
            </Typography>
            {tvData.map((item, idx) => (
              <RenderItem
                key={idx}
                year={item.year}
                title={item.title}
                director={item.director}
                role={item.role}
                image={item.image}
              />
            ))}
          </Box>
          </Box>


        </Grid>
      </Grid>

{/* Overlay FIXE en desktop, juste la moitié droite => n'empiète pas sur la galerie ni le footer */}
{!isMobile && !profileVisible && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            right: 0,
            width: '50%',            // Couvre la moitié droite
            height: 'calc(100vh - 223px)', // Laisse 80px pour le footer (ajustez selon votre footer)
            maxHeight: 'calc(100vh - 223px)',
            overflowY: 'auto',       // Si le contenu est long, on peut scroller
            background: 'linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(0,0,0,0.8) 100%)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
            p: { xs: 2, md: 6 },
            boxSizing: 'border-box',
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontFamily: 'Josefin Sans',
              fontWeight: 'bold',
              color: '#ffffff',
              mb: 2,
            }}
          >
            Jocelyne JEAN-BAPTISTE
          </Typography>
          <Box
            sx={{
              cursor: 'pointer',
              '&:hover': { textDecoration: 'underline' },
              color: '#ffffff',
              fontFamily: 'Josefin Sans',
              fontSize: '1rem',
              mb: 4,
              display: 'flex',
              alignItems: 'center',
            }}
            onClick={() => setShowFullProfile(true)}
          >
            <Box component="span" sx={{ mr: 1 }}>
              Voir le profil
            </Box>
            <Box
              component="span"
              sx={{ fontSize: '1rem', transform: 'rotate(90deg)' }}
            >
              ▼
            </Box>
          </Box>
        </Box>
      )}
      <Footer />
    </Box>
  );
}

export default Home;
